import { Skeleton } from "@dropbox/dig-components/skeleton";
import { Box } from "@dropbox/dig-foundations";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import classnames from "classnames";
import styles from "./OnboardingConnectorsSkeleton.module.css";

type Props = {
  numColumns?: number;
  numSkeletons?: number;
  className?: string;
};

export function OnboardingConnectorsSkeleton({
  numColumns = 2,
  numSkeletons = 8,
  className,
}: Props) {
  const isMobile = useIsMobileSize();

  return (
    <Box>
      <Box
        className={classnames(styles.connectorsContainer, className)}
        style={{
          gridTemplateColumns: `repeat(${isMobile ? 1 : numColumns}, 1fr)`, // Dynamic column count
        }}
      >
        {Array.from({ length: numSkeletons }, (_, i) => (
          // eslint-disable-next-line react/jsx-no-undef
          <Skeleton.Text
            key={i}
            data-testid="connectorSkeleton"
            className={styles.connectorSkeleton}
          />
        ))}
      </Box>
    </Box>
  );
}
